import React, { Component } from 'react';
import { getPlan, CreatePay, partnerApi, partnerSubscription } from './../../../../API/FetchCall';
import SimpleReactValidator from 'simple-react-validator';
import { RAZORPAY_LIVE, RAZORPAY_TEST } from '../../../../constant.js';



class Upgrade extends Component {


  constructor(props) {
    super(props);
    this.state = {
      logged: localStorage.getItem("authentication"),
      auth_data: JSON.parse(localStorage.getItem("user_data")),
      chart_data: [],
      package_list: [],
      upgradeList: [],
      pname: '', planselect: false, errors: [],
      basesubtotal: 0, subtotal: 0, discount_per: 0, discount_amount: 0, coupon_per: 0, chart_discount: 0, chart_discount_amount: 0,
      coupon_amount: 0, sgst_per: 0, cgst_per: 0, sgst_amount: 0, cgst_amount: 0, totalpayable: 0, totalselected: 0,
      partner_name: '', partner_email: '', partner_address: '', coupon_per_or: 0, coupon_amount_or: 0,
      coupon_applied: false
      // planlist: [], upgradeplanid: '', planid: 0, plan_price: '', discamt: '', originalprice: '',
      // curren_plname: '', new_plname: '', other_description: '', plan_period: '', plan_ndesc: '',
    }
    this.validator = new SimpleReactValidator();
    this.getPlanList();
    this.getChartData();
    this.getCurrentPlanList();

  }
  componentDidUpdate() {
    window.jQuery('.selectpicker').selectpicker('refresh');
  }
  componentDidMount() {
    window.jQuery('.selectpicker').selectpicker('refresh');
  }
  getPlanList() {
    let planData = JSON.stringify({
      user_type: this.state.auth_data.user_type,
    });
    getPlan(planData).then((response) => {
      if (response.status == 1) {
        this.setState({
          planlist: response.results,
        });
      }
    });
  }
  getChartData() {
    let planData = JSON.stringify({
      user_type: this.state.auth_data.user_type,
      role: 3,
      url: 'getPriceChart'
    });
    partnerSubscription(planData).then((response) => {
      if (response.status == 1) {
        console.log('response.results', response.results)
        this.setState({
          chart_data: response.results ? (response.results) : [],
        });
      }
    });
  }
  getCurrentPlanList = () => {
    const { user_type, login_id } = this.state.auth_data;
    let insdata = JSON.stringify({
      user_type: user_type,
      partner_id: login_id,
      role: 3,
      url: 'getPartnerPlanV1'
    });
    partnerSubscription(insdata).then((response) => {
      if (response.status === 1) {
        console.log("RR", response);
        this.setState({
          package_list: response.plan_list,
          upgradeList: response.upgrade_list,
          cgst_per: response.tax_data.cgst,
          sgst_per: response.tax_data.sgst,
          coupon_id: response.coupon_data.coupon_id,
          coupon_per_or: response.coupon_data.coupon_per,
          coupon_amount_or: response.coupon_data.coupon_amount,
          partner_name: response.partner.name, partner_email: response.partner.email, partner_address: response.partner.address
        })
      }
    })
  }
  handleChange = (e) => {
    let period = e.target.value;
    let nplanid = this.state.upgradeplanid;
    this.setState({
      [e.target.name]: period
    });
    this.setPrice(nplanid, period);
  }
  handleplanchange = (e) => {
    let list = this.state.planlist;
    const nplanid = e.target.value;
    let data = list.filter((item) => item.id == nplanid);
    this.setState({
      [e.target.name]: nplanid,
      plan_ndesc: data[0].other_description
    });

    let period = this.state.plan_period;
    if (period)
      this.setPrice(nplanid, period);
  }

  customeChangeCheckBox = (e, i, parent_id) => {

    let value = e.target.value;
    const propsName = e.target.name;
    let upgradeList = this.state.upgradeList;
    let booleanvalue = false;

    var ele = document.getElementsByClassName('tobechecked_' + parent_id);
    for (var k = 0; k < ele.length; k++) {
      if (ele[k].type == 'checkbox') {
        if (ele[k].checked) {
          ele[k].setAttribute('checked', false);
          ele[k].checked = false;
          booleanvalue = false;
        }
        else {
          ele[k].setAttribute('checked', true);
          ele[k].checked = true;
          booleanvalue = true;
        }
      }

      var indexatr = ele[k].getAttribute('data-index');
      upgradeList[indexatr]['is_check'] = booleanvalue;
    }

    if (propsName == 'is_check') {
      value = (upgradeList[i].is_check == false || upgradeList[i].is_check == 'false') ? true : false;

    }

    if (value)
      upgradeList[i][propsName] = false;
    else
      upgradeList[i][propsName] = true;

    upgradeList[i][propsName] = value;
    if (upgradeList[i].nplan_id && upgradeList[i].period == undefined)
      upgradeList[i]['period'] = 365;

    this.setPrice(upgradeList[i].nplan_id, upgradeList[i].period, upgradeList, i);

    let fdata = upgradeList.filter((item) => (item.is_check === true && item.nplanid != 0 && parseInt(item.period) > 0));
    if (fdata.length === 0)
      this.setState({
        basesubtotal: 0, subtotal: 0, discount_per: 0, discount_amount: 0, chart_discount: 0, chart_discount_amount: 0,
        sgst_amount: 0, cgst_amount: 0, totalpayable: 0, totalselected: 0
      });
  }

  customeChangeCheckOthers = (e, i, parent_id, checkbox_id) => {
    let THIS = this;
    let value = e.target.value;
    const propsName = e.target.name;
    let upgradeList = this.state.upgradeList;
    console.log("array", upgradeList);
    let booleanvalue = false;
    //check if any parent exist
    var eleparent = document.getElementsByClassName('chk_' + parent_id);
    for (var k = 0; k < eleparent.length; k++) {
      if (eleparent[k].checked) {
        eleparent[k].checked = false;
        booleanvalue = false;
        eleparent[k].setAttribute('checked', false);
      }
      else {
        eleparent[k].checked = true;
        eleparent[k].setAttribute('checked', true);
        booleanvalue = true;
      }
      var indexatr = eleparent[k].getAttribute('data-index');
      upgradeList[indexatr]['is_check'] = booleanvalue;
    }

    var elecurrent = document.getElementsByClassName('chk_' + checkbox_id);
    let booleanvalue2 = false;
    var ele = document.getElementsByClassName('tobechecked_' + parent_id);
    for (var l = 0; l < ele.length; l++) {

      if (ele[l].type == 'checkbox' && ele[l].id != checkbox_id) {
        if (ele[l].checked) {
          ele[l].setAttribute('checked', false);
          ele[l].checked = false;
          booleanvalue2 = false;
        }
        else {
          ele[l].setAttribute('checked', true);
          ele[l].checked = true;
          booleanvalue2 = true;
        }
      }
      var indexatr = ele[l].getAttribute('data-index');
      upgradeList[indexatr]['is_check'] = booleanvalue;
    }


    if (propsName == 'is_check') {
      value = (upgradeList[i].is_check == false || upgradeList[i].is_check == 'false') ? true : false;

    }

    if (value)
      upgradeList[i][propsName] = false;
    else
      upgradeList[i][propsName] = true;
    this.setState({
      checking: true
    })
    if (upgradeList[i].nplan_id && upgradeList[i].period == undefined)
      upgradeList[i]['period'] = 365;
    this.setPrice(upgradeList[i].nplan_id, upgradeList[i].period, upgradeList, i);

    let fdata = upgradeList.filter((item) => (item.is_check === true && item.nplanid != 0 && parseInt(item.period) > 0));
    if (fdata.length === 0)
      this.setState({
        basesubtotal: 0, subtotal: 0, discount_per: 0, discount_amount: 0,
        sgst_amount: 0, cgst_amount: 0, totalpayable: 0, totalselected: 0
      });
    setTimeout(function () {
      THIS.setState({
        checking: false
      })
    }, 1000)
  }

  customeChange = (e, i) => {
    let THIS = this;
    let value = e.target.value;
    const propsName = e.target.name;
    let upgradeList = this.state.upgradeList;
    if (propsName == 'is_check') {
      value = (upgradeList[i].is_check == false || upgradeList[i].is_check == 'false') ? true : false;

    }
    this.setState({
      checking: true
    })
    upgradeList[i][propsName] = value;
    if (upgradeList[i].nplan_id && upgradeList[i].period == undefined)
      upgradeList[i]['period'] = 365;

    this.setPrice(upgradeList[i].nplan_id, upgradeList[i].period, upgradeList, i);


    let fdata = upgradeList.filter((item) => (item.is_check === true && item.nplanid != 0 && parseInt(item.period) > 0));
    if (fdata.length === 0)
      this.setState({
        basesubtotal: 0, subtotal: 0, discount_per: 0, discount_amount: 0,
        sgst_amount: 0, cgst_amount: 0, totalpayable: 0, totalselected: 0
      });
    setTimeout(function () {
      THIS.setState({
        checking: false
      })
    }, 500)
  }

  setPrice = async (plan_id, period, upgradeList, i) => {
    console.log('setprice', plan_id, period, upgradeList, i)
    let selected_plan = plan_id;
    let list = this.state.planlist;
    console.log("selected plan", selected_plan);
    let data = list.filter((item) => item.id == selected_plan);
    console.log("plannnnn", data);
    let plan_price = data[0].plan_price;
    let base_price = data[0].base_price;
    let discount_amount = data[0].discount_amount;
    let discount_percent = data[0].discount_percent;
    if (period == 183) {
      let temp = parseFloat(data[0].base_price) % 2;
      // base_price = parseFloat(temp) > 0 ? parseFloat(data[0].base_price) + 1 : parseFloat(data[0].base_price);
      base_price = data[0].price_six;
      plan_price = data[0].price_six;
      discount_percent = 0;
      discount_amount = 0;
    }
    console.log('plan_price', plan_price);
    console.log('base_price', base_price);
    console.log('discount_amount', discount_amount);
    console.log('discount_percent', discount_percent);
    console.log('discount_percent', this.state.planid);
    if (upgradeList[i].cplan_id == 0) {
      upgradeList[i].plan_price = Math.round(plan_price);
      upgradeList[i].base_price = Math.round(base_price);
      upgradeList[i].discamt = discount_amount;
      upgradeList[i].discount_percent = discount_percent;
      upgradeList[i].other_description = `(Bewise ${data[0].plan_name} - ${upgradeList[i].cplan_name})`;
      // this.setState({
      //   plan_price: Math.round(plan_price),
      //   originalprice: base_price,
      //   discamt: discount_amount,
      //   discount: discount_percent,
      //   other_description: `(Bewise ${data[0].plan_name} - ${upgradeList[i].cplan_name})`,
      // });
    } else {
      let final_data = await this.getProrate(plan_price, period, upgradeList, i);
      upgradeList[i].plan_price = Math.round(final_data.plan_price);
      upgradeList[i].base_price = final_data.base_price;
      upgradeList[i].discamt = final_data.discamt;
      upgradeList[i].discount_percent = final_data.discount_percent;
      upgradeList[i].other_description = `(Bewise ${data[0].plan_name} - ${this.state.curren_plname})`;
    }
    upgradeList[i].new_plname = 'Bewise ' + data[0].plan_name;

      //special discount
      const { user_type, login_id } = this.state.auth_data;
      if(login_id==1026){
          upgradeList[i].base_price = (upgradeList[i].base_price-750);
          upgradeList[i].plan_price = (upgradeList[i].plan_price-750);
      }


    this.setState({
      upgradeList
    });
    console.log("upgradelist", upgradeList);
    
    this.calculateAmount(upgradeList);
  }
  async getProrate(planprice, period, upgradeList, i) {
    let last_paid = parseFloat(upgradeList[i].last_paid);
    let expire = upgradeList[i].end_date != '0000-00-00' ? new Date(upgradeList[i].end_date) : new Date();
    let startdate = upgradeList[i].start_date != '0000-00-00' ? new Date(upgradeList[i].start_date) : new Date();
    let totalDays = period;
    var today = new Date();
    const diffTimeUsed = Math.abs(startdate - today);
    const daysUsed = Math.ceil(diffTimeUsed / (1000 * 60 * 60 * 24));
    const oldperday = (last_paid / totalDays);
    const newoldprice = (last_paid - (oldperday * daysUsed));

    let payableamout = Math.round(planprice - newoldprice);
    return {
      plan_price: payableamout,
      base_price: payableamout,
      discamt: 0,
      discount_percent: 0,
    }
  }
  calculateAmount = (upgradeList) => {
    let data = upgradeList;
    let selected_count = 0;
    let fdata = data.filter((item) => (item.is_check === true && item.nplanid != 0 && parseInt(item.period) > 0));
    selected_count = fdata.length;
    let subtotal = 0, osubtotal = 0;
    let total_discount_per = 0;
    let basesubtotal = 0, cgst_amount = 0, sgst_amount = 0, total_payable = 0, chart_discount = 0,
      chart_discount_amount = 0;
    if (selected_count > 0) {
      fdata.map((item, i) => {
        subtotal = subtotal + item.plan_price;
        basesubtotal = basesubtotal + item.base_price;
      });
      osubtotal = subtotal;
      let total_discount_amt = basesubtotal - subtotal;
      let postDis = parseFloat(basesubtotal) - parseFloat(total_discount_amt);
      total_discount_per = Math.round(100 * ((parseFloat(basesubtotal) - postDis) / parseFloat(basesubtotal)));
      let coupon_amount = 0, coupon_per = 0, coupon_applied = false;
      let chartCalc = this.calculateChartAmount(fdata);
      chart_discount_amount = chartCalc.total_discount;
      subtotal = parseFloat(subtotal) - parseFloat(chartCalc.total_discount);
      chart_discount = Math.round(100 * ((parseFloat(osubtotal) - subtotal) / parseFloat(osubtotal)));
      osubtotal = subtotal;
      if (selected_count >= 1 && (this.state.coupon_amount_or > 0 || this.state.coupon_per_or > 0)) {
        if (this.state.coupon_amount_or > 0) {
          let temptotal = subtotal;
          subtotal = subtotal - parseFloat(this.state.coupon_amount_or);
          let postCoup = parseFloat(temptotal) - parseFloat(this.state.coupon_amount_or);
          coupon_amount = this.state.coupon_amount_or;
          coupon_per = (100 * ((parseFloat(temptotal) - postCoup) / parseFloat(temptotal))).toFixed(2);
        }
        if (this.state.coupon_per_or > 0) {
          coupon_per = this.state.coupon_per_or;
          coupon_amount = ((subtotal) * parseFloat(this.state.coupon_per_or) / 100).toFixed(2);
          subtotal = subtotal - parseFloat(coupon_amount);
        }
        coupon_applied = true;
      }
      if (this.state.cgst_per > 0) {
        cgst_amount = ((subtotal) * parseFloat(this.state.cgst_per) / 100).toFixed(2);
      }
      if (this.state.sgst_per > 0) {
        sgst_amount = ((subtotal) * parseFloat(this.state.sgst_per) / 100).toFixed(2);
      }
      total_payable = parseFloat(sgst_amount) + parseFloat(cgst_amount) + parseFloat(subtotal);

      this.setState({
        basesubtotal: basesubtotal, subtotal: osubtotal,
        chart_discount_amount: chart_discount_amount, chart_discount: chart_discount,
        discount_per: total_discount_per, discount_amount: total_discount_amt,
        sgst_amount: sgst_amount, cgst_amount: cgst_amount, totalpayable: Math.round(total_payable),
        totalselected: selected_count, coupon_amount: coupon_amount, coupon_per: coupon_per
      });
    }
  }
  calculateChartAmount(items) {
    items = items.filter(data => data.period == '365')
    console.log('items', items)
    let discount_amount = 0, total_amount = 0, total_sub = 0, total_discount = 0;
    let chart_data = this.state.chart_data;
    let planlist = this.state.planlist;
    let vertical_count = items.length;
    let branch_result = items.reduce(function (r, a) {
      r[a.set_id] = r[a.set_id] || [];
      r[a.set_id].push(a);
      return r;
    }, Object.create(null));
    let branch_count = Object.keys(branch_result).length;
    let arr = [];
    planlist.map((item, i) => {
      let temp = items.filter(idata => idata.nplan_id == item.id)
      arr.push({
        plan_id: item.id,
        count: temp.length,
      })
    })
    const maxPeak = arr.reduce((p, c) => p.count > c.count ? p : c);
    let calcData = chart_data.filter(data => data.package_id == maxPeak.plan_id)
    if (calcData.length > 0) {
      calcData = calcData[0];
      if (calcData.price_chart) {
        let type = typeof calcData.price_chart;
        if (type == 'string')
          calcData.price_chart = JSON.parse(calcData.price_chart)
        const branchIndex = calcData.price_chart.cols.findIndex(object => {
          return ((branch_count >= object.minVal && branch_count <= object.maxVal));
        });
        console.log('** branchIndex', branchIndex);
        for (const key of Object.keys(branch_result)) {
          let tp1 = 0, tp2 = 0;
          let vlen = branch_result[key].length;
          console.log('** vlen', vlen);
          let arrTemp = branch_result[key];
          vlen = vlen - 1;
          tp1 = parseFloat(calcData.price_chart.rows[vlen].rcolVal[branchIndex]);
          if (branchIndex > 0) {
            tp2 = parseFloat(calcData.price_chart.rows[vlen].rcolVal[0]);
            tp1 = parseFloat(calcData.price_chart.rows[vlen].rcolVal[branchIndex]);
          }
          console.log('** %', tp2, tp1);
          let subtotal = 0;
          arrTemp.map((cdata, i) => {
            subtotal = subtotal + cdata.plan_price;
          })
          total_amount = total_amount + subtotal
          console.log('subtotal 1', subtotal);
          if (branchIndex > 0) {
            if (tp2 > 0) {
              let d1 = ((subtotal) * parseFloat(tp2) / 100);
              total_discount = total_discount + d1;
              subtotal = subtotal - d1;
            }
          }
          console.log('subtotal 2', subtotal);
          if (tp1 > 0) {
            let d2 = ((subtotal) * parseFloat(tp1) / 100);
            total_discount = total_discount + d2;
            subtotal = subtotal - d2;
          }
          total_sub = total_sub + subtotal;
        }
        console.log('subtotal 5', total_amount, total_discount, total_sub);
        // let tempVlen = calcData.price_chart.rows.length;
        // if (vertical_count >= tempVlen) {
        //   vertical_count = tempVlen;
        // }
        // let verticalIndex = vertical_count - 1;
        // const discountPercent = calcData.price_chart.rows[verticalIndex].rcolVal[branchIndex];
        // let total = 0;
        // items.map((data, i) => {
        //   total = total + data.plan_price;
        // })
        // if (discountPercent > 0)
        //   discount_amount = ((total) * parseFloat(discountPercent) / 100).toFixed(2);
        // console.log('calcData.price_chart b', total, discount_amount, discountPercent)
      }
    }
    return { total_amount, total_discount, total_sub };
  }
  render() {

    this.validator.purgeFields();
    return (
      <React.Fragment>
        <div class="box-shadow-custom desktoponly">
          <div className='row'>
            <p className='alert'>* Check items to add billing</p>
            <p className='alert'>* if you want to delete any of schools / categories / branches, please do so under branches or categories</p>
            <div class="col-md-12">
              <table className='table-responsive content-sec col-md-12 col-xs-12 pad-no mar-t-no'>
                <thead>
                  <tr>
                    <th width="10%">Check for Billing</th>
                    <th>Name</th>
                    <th>Category</th>
                    <th>Current Plan</th>
                    <th>Select Package</th>
                    <th>Period</th>
                    <th>Amount</th>
                    {/* <th>Discount</th>
                    <th>Amount</th> */}
                  </tr>
                </thead>
                <tbody>
                  {this.state.upgradeList.map((item, i) => {
                    return (
                      <tr>
                        <td>
                          {item.parent_id != 0 && item.cplan_id == 0 && (

                            <input type='checkbox' data-index={i} id={item.main_id} className={'form-control checkbox-cus tobechecked_' + item.parent_id + ' chk_' + item.main_id}
                              name='is_check' defaultChecked={item.is_check == true ? true : false} onChange={(e) => this.customeChangeCheckOthers(e, i, item.parent_id, item.main_id)} />

                          )}
                          {item.parent_id == 0 && item.cplan_id == 0 && (

                            <input type='checkbox' data-index={i} className={'form-control checkbox-cus tobechecked_' + item.parent_id + ' chk_' + item.main_id}
                              name='is_check' defaultChecked={item.is_check == true ? true : false} onChange={(e) => this.customeChangeCheckBox(e, i, item.main_id)} />

                          )}
                          {item.cplan_id != 0 && (

                            <input type='checkbox' data-index={i} className={'form-control checkbox-cus'}
                              name='is_check' defaultChecked={item.is_check == true ? true : false} onChange={(e) => this.customeChange(e, i)} />

                          )}
                        </td>
                        <td>
                          <p>{item.organisation_name}</p>
                        </td>
                        <td>
                          <p>{item.category_name}</p>
                        </td>
                        <td>
                          <p>{item.cplan_name}</p>
                        </td>
                        <td>
                          <select title='Select' onChange={(e) => this.customeChange(e, i)} name='nplan_id'
                            className='form-control selectpicker' value={item.nplan_id}>
                            {this.state.package_list.map((items, i) => {
                              {
                                if (items.id != item.cplan_id && items.id > item.cplan_id) {

                                  return (
                                    <option value={items.id} >
                                      {items.plan_name}
                                    </option>
                                  )
                                }
                              }
                            })
                            }
                          </select>
                        </td>
                        <td>
                          {item.nplan_id > 0 && (
                            <select
                              name="period"
                              value={item.period}
                              onChange={(e) => this.customeChange(e, i)}
                              className='form-control selectpicker plan_period' title='Period'>
                              <option value='365'>12 Months</option>
                             
                            </select>
                          )}
                        </td>
                        <td className='text-right'>
                          <p>{item.base_price ? Number(item.base_price).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,') : 0}</p>
                        </td>
                        {/* <td className='text-right'>
                          <p>{item.discamt ? item.discamt : 0}</p>
                        </td>
                        <td className='text-right'>
                          <p>{item.plan_price ? item.plan_price : 0}</p>
                        </td> */}
                      </tr>
                    )
                  })
                  }
                </tbody>
                <tfoot>
                  <tr>
                    <td colSpan='6' className='text-right'><b>Total</b></td>
                    <td className='text-right'>{Number(this.state.basesubtotal).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}</td>
                  </tr>
                  {this.state.discount_amount > 0 && (
                    <tr>
                      <td colSpan='6' className='text-right'><b>Early Bird Offer</b></td>
                      <td className='text-right'>{Number(this.state.discount_amount).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}</td>
                    </tr>
                  )}
                  {this.state.chart_discount_amount > 0 && (
                    <tr>
                      <td colSpan='6' className='text-right'><b>Offer</b></td>
                      <td className='text-right'>{Number(this.state.chart_discount_amount).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}</td>
                    </tr>
                  )}
                  <tr>
                    <td colSpan='6' className='text-right'><b>Sub Total</b></td>
                    <td className='text-right'>{Number(this.state.subtotal).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}</td>
                  </tr>
                  {(this.state.coupon_amount_or > 0 || this.state.coupon_per_or > 0) && (
                    <tr>
                      <td colSpan='6' className='text-right'><b>Coupon applied ({this.state.coupon_per + ' %'})</b></td>
                      <td className='text-right'>{Number(this.state.coupon_amount).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}</td>
                    </tr>
                  )}
                  <tr>
                    <td colSpan='6' className='text-right'><b>SGST  {this.state.sgst_per > 0 && (`(${this.state.sgst_per}%)`)}</b></td>
                    <td className='text-right'>{Number(this.state.sgst_amount).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}</td>
                  </tr>
                  <tr>
                    <td colSpan='6' className='text-right'><b>CGST {this.state.cgst_per > 0 && (`(${this.state.cgst_per}%)`)}</b></td>
                    <td className='text-right'>{Number(this.state.cgst_amount).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}</td>
                  </tr>
                  <tr>
                    <td colSpan='6' className='text-right'><b>Total Payable (₹)</b></td>
                    <td className='text-right'>{Number(this.state.totalpayable).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}</td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
          {this.state.totalselected > 0 &&
            <div class="row">
              <div class="col-md-12 col-xs-12 btn-bdr text-right pad-hor-no mar-btm">
                <button type='submit' className="btn btn-primary"
                  onClick={this.displayRazorpay}
                >SUBMIT</button>
              </div>
            </div>
          }

          {/* <div className='col-md-8'>
            <div class="row">
              <div class="form-group col-md-6">
                <label>Package Name</label>
                <input type='text' value={this.state.pname} className='form-control' />
              </div>
              <div class="form-group col-md-6">
                <button className='btn btn-sm blue-btn' onClick={() => this.handleplan()} style={{ marginTop: '27px' }}>Upgrade/ Subscribe</button>
              </div>
            </div>
            {this.state.planselect ?
              <div>
                <form>
                  <div class="row">
                    <div class="form-group col-md-6">
                      <label>Select Plan</label>
                      <select
                        name="upgradeplanid"
                        value={this.state.upgradeplanid}
                        onChange={this.handleplanchange}
                        className='form-control selectpicker upgradeplanid' title='Select Plan'>
                        {this.state.planlist.length > 0 &&
                          this.state.planlist.map((item, i) => {
                            {
                              if (item.id != this.state.planid && item.id > this.state.planid) {

                                return (

                                  <option value={item.id} >
                                    {'BeWise ' + item.plan_name}
                                  </option>
                                )
                              }
                            }
                          })
                        }
                      </select>
                      {this.validator.message('Plan', this.state.upgradeplanid, 'required', { className: 'text-danger' })}
                    </div>
                  </div>
                  <div class="row">
                    <div class="form-group col-md-6">
                      <label>Select Period</label>
                      <select
                        name="plan_period"
                        value={this.state.plan_period}
                        onChange={this.handleChange}
                        className='form-control selectpicker plan_period' title='Select Period'>
                        <option value='365'>12 Months</option>
                        <option value='183'>6 Months</option>
                      </select>
                      {this.validator.message('Plan', this.state.plan_period, 'required', { className: 'text-danger' })}
                    </div>

                  </div>
                  {this.state.plan_period == 365 && (
                    <div class="row">
                      <div class="form-group col-md-6">
                        <label>Base Price</label>
                        <input type='text' className='form-control' value={this.state.originalprice} />
                      </div>
                    </div>
                  )}
                  {this.state.discount > 0 && (
                    <div class="row">
                      <div class="form-group col-md-6">
                        <label>Discount (%)</label>
                        <input type='text' className='form-control' value={this.state.discount} />
                      </div>
                    </div>
                  )}
                  <div class="row">
                    <div class="form-group col-md-6">
                      <label>Payable Amount</label>
                      <input type='text' className='form-control' value={this.state.plan_price} />
                    </div>
                  </div>
                  <div class="row">
                    <div class="form-group col-md-6">
                      <button type='submit' className="btn blue-btn"
                        onClick={this.displayRazorpay}
                      >SUBMIT</button>
                    </div>
                  </div>
                </form>
              </div>
              :
              this.state.planid != 0 && (
                <div>
                  <div class="row">
                    <div class="form-group col-md-6">
                      <label>Subscription Date</label>
                      <input type='text' className='form-control' value={this.state.payment_date} />
                    </div>
                  </div>
                  <div class="row">
                    <div class="form-group col-md-6">
                      <label>Expire Date</label>
                      <input type='text' className='form-control' value={this.state.enddate} />
                    </div>
                  </div>
                  <div class="row">
                    <div class="form-group col-md-6">
                      <label>Payment Details</label>
                      <textarea className='form-control' value={this.state.pamount} rows={4} ></textarea>
                    </div>
                  </div>
                </div>
              )
            }
          </div>
          <div className='col-md-4'>
            <div className='row'>
              {(this.state.plan_ndesc && this.state.planid == 0) && (
                <div className='form-group col-md-12'>
                  <div dangerouslySetInnerHTML={{ __html: this.state.plan_ndesc }}></div>
                </div>
              )}
            </div>
          </div> */}
        </div>
        <div class="mobileonly hidden">
          <div class="box-shadow-custom ">
            <div className='row'>
              <p className='alert'>* Check items to add billing</p>
              <p className='alert'>* if you want to delete any of schools / categories / branches, please do so under branches or categories</p>
              <div class="col-md-12">

                {this.state.upgradeList.map((item, i) => {
                  return (
                    <div class="mobileinvline box-shadow-custom">
                      <div class="foldtl">{item.parent_id != 0 && item.cplan_id == 0 && (

                        <input type='checkbox' data-index={i} id={item.main_id} className={'form-control checkbox-cus tobechecked_' + item.parent_id + ' chk_' + item.main_id}
                          name='is_check' defaultChecked={item.is_check == true ? true : false} onChange={(e) => this.customeChangeCheckOthers(e, i, item.parent_id, item.main_id)} />

                      )}
                        {item.parent_id == 0 && item.cplan_id == 0 && (

                          <input type='checkbox' data-index={i} className={'form-control checkbox-cus tobechecked_' + item.parent_id + ' chk_' + item.main_id}
                            name='is_check' defaultChecked={item.is_check == true ? true : false} onChange={(e) => this.customeChangeCheckBox(e, i, item.main_id)} />

                        )}
                        {item.cplan_id != 0 && (

                          <input type='checkbox' data-index={i} className={'form-control checkbox-cus'}
                            name='is_check' defaultChecked={item.is_check == true ? true : false} onChange={(e) => this.customeChange(e, i)} />

                        )} </div>
                      <div><b>Name :</b> <br /> {item.organisation_name}</div>
                      <div><b>Category :</b> <br /> {item.category_name}</div>
                      <div><b>Current Plan :</b> <br /> {item.cplan_name}</div>
                      <div><b>Select Package :</b> <br /> <select title='Select' onChange={(e) => this.customeChange(e, i)} name='nplan_id'
                        className='form-control selectpicker' value={item.nplan_id}>
                        {this.state.package_list.map((items, i) => {
                          {
                            if (items.id != item.cplan_id && items.id > item.cplan_id) {

                              return (
                                <option value={items.id} >
                                  {items.plan_name}
                                </option>
                              )
                            }
                          }
                        })
                        }
                      </select></div>
                      <div><b>Period :</b> <br /> {item.nplan_id > 0 && (
                        <select
                          name="period"
                          value={item.period}
                          onChange={(e) => this.customeChange(e, i)}
                          className='form-control selectpicker plan_period' title='Period'>
                          <option value='365'>12 Months</option>
                          <option value='183'>6 Months</option>
                        </select>
                      )} </div>
                      <div><b>Amount :</b> <br /> {item.base_price ? item.base_price : 0}</div>

                    </div>
                  )
                })
                }

              </div>
              {this.state.totalselected > 0 &&
                <div class="col-md-12 col-xs-12 btn-bdr text-right pad-hor-no mar-btm">
                  <button type='submit' className="btn btn-primary"
                    onClick={this.displayRazorpay}
                  >SUBMIT</button>
                </div>
              }
            </div>
          </div>
        </div>
      </React.Fragment >
    );

  }
  displayRazorpay = async (e) => {
    e.preventDefault();
    if (this.validator.allValid()) {
      const res = await this.loadScript(
        "https://checkout.razorpay.com/v1/checkout.js"
      );
      if (!res) {
        alert("Razorpay SDK failed to load. Are you online?");
        return;
      }
      let ins = JSON.stringify({
        amount: this.state.totalpayable
      });
      CreatePay(ins).then((res) => {
        this.setState({
          amount: res.amount,
          order_id: res.id,
          currency: res.currency,
        });
        this.payinfo();
      });
    } else {
      this.validator.showMessages();
      this.forceUpdate();
    }
  }
  payinfo() {
    var This = this;
    var payment_data;
    const options = {
      key: RAZORPAY_TEST, // Enter the Key ID generated from the Dashboard
      amount: this.state.amount.toString(),
      currency: this.state.currency,
      name: this.state.partner_name,
      description: "Plan Upgrade - Partner Program",
      // image: { logo },
      // order_id: this.state.order_id,
      handler: async function (response) {
        console.log('response', response);
        This.handlePaySubmit(response);
        payment_data = response.razorpay_payment_id;
        const data = {
          // orderCreationId: this.state.order_id,
          razorpayPaymentId: response.razorpay_payment_id,
          razorpayOrderId: response.razorpay_order_id,
          razorpaySignature: response.razorpay_signature,
        };
        //  const result = await axios.post("/payment/success", data);
      },
      prefill: {
        name: this.state.partner_name,
        email: this.state.partner_email,
      },
      notes: {
        address: this.state.partner_address,
      },
      theme: {
        color: "#61dafb",
      },
    };
    const paymentObject = new window.Razorpay(options);
    paymentObject.open();

  }

  loadScript(src) {
    return new Promise((resolve) => {
      const script = document.createElement("script");
      script.src = src;
      script.onload = () => {
        resolve(true);
      };
      script.onerror = () => {
        resolve(false);
      };
      document.body.appendChild(script);
    });
  }


  // handlePaySubmit = () => {
  handlePaySubmit = (response) => {
    let razorpay_payment_id = response.razorpay_payment_id;

    if (razorpay_payment_id != '') {
      let ins = '';
      let upgradeList = this.state.upgradeList.filter((item) => (item.is_check === true && item.nplanid != 0 && parseInt(item.period) > 0));
      ins = JSON.stringify({
        razorpay_payment_id: response.razorpay_payment_id,
        razorpay_order_id: response.razorpay_payment_id,
        razorpay_signature: response.razorpay_signature,
        basesubtotal: this.state.basesubtotal,
        subtotal: this.state.subtotal,
        discount_per: this.state.discount_per,
        coupon_id: this.state.coupon_applied ? this.state.coupon_id : 0,
        discount_amount: this.state.discount_amount, coupon_per: this.state.coupon_per,
        coupon_amount: this.state.coupon_amount, sgst_per: this.state.sgst_per,
        cgst_per: this.state.cgst_per, sgst_amount: this.state.sgst_amount,
        cgst_amount: this.state.cgst_amount, totalpayable: this.state.totalpayable, totalselected: this.state.totalselected,
        chart_discount_amount: this.state.chart_discount_amount,
        chart_discount: this.state.chart_discount,
        user_type: this.state.auth_data.user_type,
        user_paytype: 1,
        upgradeList: upgradeList,
        invoice_type: 2,
        login_id: this.state.auth_data.login_id,
        url: 'updatevendorplan',
        role: 3
      });
      // console.log('update values', JSON.parse(ins));
      // return false;
      partnerSubscription(ins).then((res) => {
        let toastr = '';
        if (res.status === 1) {
          toastr = window.toastr.success;
          toastr('', 'Your plan has been upgraded.', {
            positionClass: "toast-bottom-right",
            containerId: "toast-bottom-right"
          });
          this.state.auth_data.is_active = 1;
          localStorage.setItem('user_data', JSON.stringify(this.state.auth_data));
          localStorage.setItem('is_active', 1);
          setTimeout(function () {
            window.location.reload();
          }, 2000);
        } else {
          let er = res.message
          toastr = window.toastr.error; //warning
          toastr(er, toastr, {
            positionClass: "toast-bottom-right",
            containerId: "toast-bottom-right"
          });
        }
      });
    } else {
      let toastr = '';
      toastr = window.toastr.error; //warning
      toastr('', 'Failed to Pay', {
        positionClass: "toast-bottom-right",
        containerId: "toast-bottom-right"
      });
    }
  }
}

export default Upgrade;


// WEBPACK FOOTER //
// ./src/components/bewise/partners/subscribe/upgrade.jsx